import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { scrollToComprar } from '../utils';
const bonuses = [{
  title: 'Recetario de 30 comidas caseras',
  desc: 'Un recetario exclusivo con opciones variadas de pollo, carne, cerdo y pescado para que tu perro nunca se aburra.',
  value: '$15.000',
  img: 'https://cdn.magicpatterns.com/uploads/uvNGgsGidFLKG9uHi5QDq9/IMG_0534.JPG.jpg'
}, {
  title: 'Guía de transición paso a paso',
  desc: 'El protocolo exacto de 14 días para cambiar de croquetas a comida natural sin que tu perro sufra problemas digestivos.',
  value: '$10.000',
  img: 'https://cdn.magicpatterns.com/uploads/hoE7rawVssQaoSxhneLzjM/IMG_0535.JPG.jpg'
}, {
  title: 'Lista de alimentos prohibidos',
  desc: 'Una guía rápida para pegar en la heladera con todos los alimentos humanos que son tóxicos para los perros.',
  value: '$5.000',
  img: 'https://cdn.magicpatterns.com/uploads/dnt8VRf56haJcsLxe3UYtm/IMG_0536.JPG.jpg'
}, {
  title: 'Planificador semanal de comidas',
  desc: 'Plantillas imprimibles para organizar las compras y las viandas de la semana, ahorrando tiempo y dinero.',
  value: '$8.000',
  img: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&q=80&w=600'
}];
export function Bonuses() {
  return <section className="py-12 md:py-16 px-4 bg-white" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-8 md:mb-10" data-id="element-17">
          <div className="inline-flex items-center justify-center gap-2 bg-accent/10 text-accent font-bold px-4 py-2 rounded-full mb-4" data-id="element-18">
            <Gift size={20} data-id="element-19" />
            <span data-id="element-20">OFERTA ESPECIAL</span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-21">
            Llevate estos bonos{' '}
            <span className="text-accent underline decoration-4 underline-offset-4" data-id="element-22">
              GRATIS POR HOY
            </span>
          </h2>
          <p className="text-lg text-brown-light max-w-2xl mx-auto" data-id="element-23">
            Con tu compra del ebook principal, te llevás todos estos
            complementos sin cargo adicional para asegurar tu éxito.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-24">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cream rounded-2xl overflow-hidden border border-cream-dark shadow-sm flex flex-col sm:flex-row group cursor-pointer" onClick={scrollToComprar} data-id="element-25">
              <div className="sm:w-2/5 h-48 sm:h-auto relative overflow-hidden" data-id="element-26">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-27" />
                <div className="absolute top-2 left-2 bg-accent text-white text-xs font-bold px-2 py-1 rounded shadow" data-id="element-28">
                  BONO #{i + 1}
                </div>
              </div>
              <div className="p-6 sm:w-3/5 flex flex-col justify-center" data-id="element-29">
                <h3 className="font-bold text-primary text-xl mb-2" data-id="element-30">
                  {bonus.title}
                </h3>
                <p className="text-sm text-brown-light mb-4" data-id="element-31">{bonus.desc}</p>
                <div className="mt-auto flex items-center gap-2" data-id="element-32">
                  <span className="text-sm text-gray-400 line-through" data-id="element-33">
                    Valor {bonus.value}
                  </span>
                  <span className="text-accent font-bold" data-id="element-34">¡HOY GRATIS!</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}